import { Mapper } from "../../../../base/utils/mapper";
import { MedicationEntity } from "../../../../domain/models/consult/medications.entity";
import { MedicationModel } from "../entities/medications.entity";


export class MedicationImplementationRepositoryMapper extends Mapper<MedicationEntity, MedicationModel> {
    mapFrom(param: MedicationEntity): MedicationModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: MedicationModel): MedicationEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}